import { WfsParametersV1 } from "../../../types/Wfs/WfsParametersV1";
import { WfsParametersV2 } from "../../../types/Wfs/WfsParametersV2";
import WfsParametersDisplayV1 from "./WfsParametersDisplayV1";
import WfsParametersDisplayV2 from "./WfsParametersDisplayV2";

export interface WfsParametersDisplayProps {
  areaDescription: string | undefined;
  wfsParameters: WfsParametersV1 | WfsParametersV2;
}

const WfsParametersDisplay = ({
  areaDescription,
  wfsParameters,
}: WfsParametersDisplayProps) => {
  return (
    <>
      {wfsParameters.$type === "v1" && (
        <WfsParametersDisplayV1
          areaDescription={areaDescription}
          wfsParameters={wfsParameters as WfsParametersV1}
        />
      )}
      {wfsParameters.$type === "v2" && (
        <WfsParametersDisplayV2
          areaDescription={areaDescription}
          wfsParameters={wfsParameters as WfsParametersV2}
        />
      )}
    </>
  );
};

export default WfsParametersDisplay;
